export default "__VITE_ASSET__BKdYy6SS__"